
<template>
  <div class="home">
    <bannera/>
    <contenta 
    :routerPath="routerPath"
    />
    <footera />
  </div>
</template>

<script>
import "../../assets/js/pcRem";
import "../../assets/styles/common.css";

import bannera from "../../components/pc/banner.vue";
import contenta from "../../components/pc/content.vue";
import footera from "../../components/pc/footer.vue";
export default {
  name: "App",
  components: {
    bannera,
    contenta,
    footera
  },
  data() {
    return { 
      //objName: "gxtheme/2022xsd",
      routerPath:"",//当前路由地址
    };
  },
  methods: {
    setRouterPath(){
      this.routerPath =window.location.pathname;
      return ;
    },

    init() {
      this.setRouterPath();
    }
  },
  mounted() {
    let that =this
    that.init();
  }
};
</script>

<style lang="scss" scoped>
</style>

